//YUI
export type YUIContext = any;

export type bulmaCollapsible = any;
export type EntityCreateCallback = (entity: Entity, WentityNode: BABYLON.AbstractMesh | BABYLON.Mesh | BABYLON.TransformNode, productNumber: string) => any;
export type ModuleCreateCallback = (module: Module, moduleNode: BABYLON.TransformNode) => any;

export enum MeshVisibility {
  VISIBLE = 1,
  HIDDEN = 2,
  FADED = 4,
  HIGHLIGHTED = 8,
}

export enum Placement {
  LEFT_FRONT = "left_front",
  LEFT_BACK = "left_back",
  RIGHT_FRONT = "right_front",
  RIGHT_BACK = "right_back",
  MIDDLE_LEFT = "middle_left",
  MIDDLE_RIGHT = "middle_right",
}

export type LegPlacement = {
  legType: string;
  placement: Placement;
  direction?: Direction;
  positionX?: number;
  positionZ?: number;
  offsetX?: number;
  offsetY?: number;
  rotation?: number;
};

//Interfaces

export interface User {
    displayName: string,    
    contactId: number,    
    isB2C: boolean
}

export interface Series {
  id: number;
  SeriesItemNumber: string;
  name: string;
  thumbnail: string;
}

export interface SeriesData {
  id: number;
  name: string;
  categories: Array<string>;
  thumbnail: string;
  materials: Array<Material>;
  defaultMaterial: string;
  presets: Array<Preset>;
  legPackages: Array<LegPackage>;
  accessories: Accessory[];
  customOptions: CustomOption[];
}

export interface Accessory {
  name: string;
  description: string;
  accessoryGroup: string;
  itemType: string;
  productNumber: string;
  priceLists: ProductPriceList[];
}

export interface CustomOption {
    id: string;
    name: string;
    perModule: boolean;
    productNumber: string;
    priceAddOnGroup: string;
    priceLists: CustomOptionPrice[];
}

export interface CustomOptionPrice {
    description: string;
    priceGroup: string;
    pricePer: string;
    productType: string;
    items: string[];
    accessories: string[];
    price: ProductPrice;
}

export interface LegPackage {
  legs: Array<Leg>;
  name: string;
  identifier: string;
  type: string;
  surface: string;
  height: number;
  priceGroups: string[];
}

export interface Leg {
  id: number;
  model: string;
  productNumber: string;
  thumbnail: string;
  legShapeSize: any;
  legRotation: number;
  legOffsetFromFront: number;
  legOffsetFromSide: number;
  type: LegType;
  surface: string;
  height: number;
}

export interface LegType {
  name: string;
  identifier: string;
}

export interface Preset {
  id: string;
  name: string;
  config: string;
  thumbnail: string;
}

export interface ProductCategory {
  id: number;
  name: string;
  model: string;
  type: string;
  productType: string;
  products: Product[];
}

export interface Product {
  id: number;
  name: string;
  model: string;
  productNo: string;
  axProductNo: string;
  series: number;
  perfionIdentifier: string;
  categories: Array<string>;
  width: number;
  height: number;
  depth: number;
  /** Angled (wedge) modules: degrees the left (+X) side is turned inward towards the front (0 or missing = straight) */
  leftSideAngle?: number;
  /** Angled (wedge) modules: degrees the right (-X) side is turned inward towards the front (0 or missing = straight) */
  rightSideAngle?: number;
  type: string;
  isFlipped: boolean;
  isClosing: boolean;
  isComplete: boolean;
  thumbnail: string;
  connectors: Connector[];
  cushionPackages: CushionPackage[];
}

export interface CushionPackage {
  isDefault: boolean;
  name: string;
  variants: CushionPackageVariant[];
}

export interface CushionPackageItem {
  name: string;
  quantity: number;
}

export interface CushionPackageVariant {
  name: string;
  customerInfoText: string,
  connectionType: string;
  productNo: string;
  axProductNo: string;
  isFlipped: boolean;
  model: string;
  legPackageID: string;
  legPlacementAdditionalOffsetBack?: number | undefined;
  legPlacementAdditionalOffsetFront?: number | undefined;
  legPlacementAdditionalOffsetLeft?: number | undefined;
  legPlacementAdditionalOffsetRight?: number | undefined;
  legPlacementFCIAdditionalAngle?: number | undefined;
  pricelists: ProductPriceList[];
  legs: ProductLeg[];
  recommendedCushions: CushionPackageItem[];
}

export interface ProductLeg {
  type: string;
  amount: string;
}

export interface ProductPriceList {
  currency: string;
  name: string;
  prices: Price[];
}

export interface ProductPrice {
  currency: string;
  name: string;
  price: number;
}

export interface Price {
  [s: string]: number;
}

export interface Texture {
  id: string;
  name: string;
  blobUrl: string;
  filepath: string;
}

export interface Material {
  id: string;
  name: string;
  productNumber: string;
  type: string;
  group: string;
  //folderName?: string,
  priceGroup: string;
  rollWidth: number;
  properties: {
    metalness: number;
    roughness: number;
    sheen: number;
    detailbump: number;
    ao: number;
    tileU: number;
    tileV: number;
  };
}

export interface MaterialFilter {
  key: string;
  value: string;
}

export interface Connector {
  id: string;
  position: BABYLON.Vector3;
  rotation: BABYLON.Vector3;
  normal: BABYLON.Vector3;
  direction: Direction
  /** Length of the module side the connector sits in the middle of (used for snapping) */
  sideLength: number;
}

export interface ApiProject {
  added: Date;
  modified: Date;
  identifier: string;
  name: string;
  seller: string;
  phone: string;
  status: number;
  configurations: { key: any; series: string; data: string }[];
}

export enum Direction {
    "NONE",
   "BACK",
   "FRONT",
   "LEFT",
   "RIGHT"
}

export interface Project {
  added: Date;
  modified: Date;
  identifier: string;
  name: string;
  seller: string;
  phone: string;
  status: number;
  configurations: Array<Configuration>;
}

export interface Configuration {
  key: any;
  series: string;
  image?: string;
  drawing?: string;
  data: ConfigurationData;
}

export interface ConfigurationData {
  id: string;
  offsetY: number;
  material: string;
  leg: string;
  modules: Module[];
  thumbnail: string;
  options: { [key: string]: string | boolean | number };
  addons?: { productNo: string; amount: number }[];
  customOptions?: { id: string; value: string }[];
}

export interface Module {
  id: any;
  entities: Entity[];
  position: BABYLON.Vector3;
  rotation: BABYLON.Vector3;
  uniqueId: number;
}

export interface Entity {
  id: any;
  uniqueId: number;
  parentId: string;
  attachId: string;
  connections: Connection[];
  connectors: Connector[];  
  rotation: BABYLON.Vector3;
  position: BABYLON.Vector3;
  category: string;
  type: string;
  variant: string;
  productNo: string;
  variantProductNo: string;
  customOptions?: { id: string; value: string }[];
}

export interface PriceOption {
  id: string;
}

export interface Connection {
  id: string;
  entityId: string;
}

export interface ConnectorInfo {
  entityNode: BABYLON.TransformNode | BABYLON.AbstractMesh | BABYLON.Mesh;
  connectorNode: BABYLON.TransformNode | BABYLON.AbstractMesh | BABYLON.Mesh;
  isEnabled: boolean;
  sourceConnectorNode?: BABYLON.TransformNode | BABYLON.AbstractMesh | BABYLON.Mesh;
}

export interface PriceOption {
  id: string;
  name: string;
  dataType: string;
  thumbnail: string;
  options: Array<PriceOption>;
}

export interface ProjectFilter {
  search: string;
  hideInactive: boolean;
  currentPage: number;
  itemsShown: number;
}

export interface SeriesFilter {
  search: string;
}

export interface ModuleSummaryElement {
  axProductNo: string;
  variantProductNo: string;
  variantName: string;
  productNo: string;
  customerInfoText: string;
  currency: string;
  price: number;
  legPackageId: string;
  amount: number;
  entity: string;
  extras: {
    name: string;
    optionId: string;
    optionValue: string;
    productNo: string;
    price: number;
  }[];
}

export interface ModuleSummaryAccessory {
    name: string;
    productNo: string;
    currency: string;
    price: number;
    amount: number;
    extras: {
        name: string;
        optionId: string;
        optionValue: string;
        productNo: string;
        price: number;
    }[];
}

export interface ModuleSummaryCustomOption {
  name: string;
  productNo: string;
  currency: string;
  totalprice: number;
  amount: number;
}

export type AdjacentEntity = {
  direction: "LEFT" | "RIGHT" | "BACK" | "FRONT" | "LEFT_BACK" | "LEFT_FRONT" | "RIGHT_BACK" | "RIGHT_FRONT";
  directionVector: BABYLON.Vector3;
  entity: Entity;
}